var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "login-container" }, [
    _c("div", { staticClass: "content" }, [
      _c("div", { staticClass: "login-box-left" }),
      _vm._m(0),
      _c(
        "div",
        { staticClass: "login-box-right" },
        [
          _c(
            "el-form",
            {
              ref: "loginForm",
              staticClass: "login-form",
              attrs: {
                autoComplete: "on",
                model: _vm.loginForm,
                rules: _vm.loginRules,
                "label-position": "left"
              }
            },
            [
              _c(
                "el-form-item",
                { attrs: { prop: "username" } },
                [
                  _c("span", {
                    staticClass: "blue-icon iconfont icon-yonghu_zhanghao_wode"
                  }),
                  _c("el-input", {
                    attrs: {
                      name: "username",
                      type: "text",
                      autoComplete: "on",
                      placeholder: "请输入登录账号"
                    },
                    model: {
                      value: _vm.loginForm.username,
                      callback: function($$v) {
                        _vm.$set(_vm.loginForm, "username", $$v)
                      },
                      expression: "loginForm.username"
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { prop: "password" } },
                [
                  _c("span", {
                    staticClass: "blue-icon",
                    class:
                      _vm.pwdType === "password"
                        ? "icon iconfont icon-xianshi_chakan"
                        : "icon iconfont icon-yincang",
                    on: { click: _vm.showPwd }
                  }),
                  _c("el-input", {
                    attrs: {
                      name: "password",
                      type: _vm.pwdType,
                      autoComplete: "on",
                      placeholder: "请输入密码"
                    },
                    nativeOn: {
                      keyup: function($event) {
                        if (
                          !$event.type.indexOf("key") &&
                          _vm._k(
                            $event.keyCode,
                            "enter",
                            13,
                            $event.key,
                            "Enter"
                          )
                        ) {
                          return null
                        }
                        return _vm.handleLogin.apply(null, arguments)
                      }
                    },
                    model: {
                      value: _vm.loginForm.password,
                      callback: function($$v) {
                        _vm.$set(_vm.loginForm, "password", $$v)
                      },
                      expression: "loginForm.password"
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { prop: "tenantid" } },
                [
                  _c("span", {
                    staticClass: "blue-icon icon iconfont icon-yonghuguanli"
                  }),
                  _c(
                    "el-select",
                    {
                      attrs: { placeholder: "请选择" },
                      on: { change: _vm.tenantChange },
                      model: {
                        value: _vm.tenant,
                        callback: function($$v) {
                          _vm.tenant = $$v
                        },
                        expression: "tenant"
                      }
                    },
                    _vm._l(_vm.tenants, function(item) {
                      return _c("el-option", {
                        key: item.value,
                        attrs: { label: item.label, value: item.value }
                      })
                    }),
                    1
                  )
                ],
                1
              ),
              _vm.isIdentityAuth
                ? _c(
                    "div",
                    { staticClass: "tips" },
                    [
                      _c(
                        "router-link",
                        { attrs: { to: "/oidcRedirect" } },
                        [
                          _c("el-badge", { attrs: { "is-dot": "" } }, [
                            _vm._v("接口服务器启用了Oauth认证，请点击这里登录")
                          ])
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _c(
                    "el-form-item",
                    { staticClass: "btn" },
                    [
                      _c(
                        "el-button",
                        {
                          directives: [{ name: "waves", rawName: "v-waves" }],
                          staticClass: "login-btn",
                          attrs: { type: "primary", loading: _vm.loading },
                          nativeOn: {
                            click: function($event) {
                              $event.preventDefault()
                              return _vm.handleLogin.apply(null, arguments)
                            }
                          }
                        },
                        [_vm._v(" 登 录 ")]
                      )
                    ],
                    1
                  )
            ],
            1
          )
        ],
        1
      )
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "login-logo-box" }, [
      _c("div", { staticClass: "login-logo-bar" }, [
        _c("div", { staticClass: "logo-logo" }, [
          _c("div", { staticClass: "logo" })
        ]),
        _c("div", { staticClass: "logo-text" }, [_vm._v("流程管理")])
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }